import { render, staticRenderFns } from "./dlt_sss_yc.vue?vue&type=template&id=64d61afc&scoped=true"
import script from "./dlt_sss_yc.vue?vue&type=script&lang=js"
export * from "./dlt_sss_yc.vue?vue&type=script&lang=js"
import style0 from "./dlt_sss_yc.vue?vue&type=style&index=0&id=64d61afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d61afc",
  null
  
)

export default component.exports